<template>
  <div>
    <div v-if="item" class="row">
      <div class="col-md-7 mb-4 text-center">

        <a v-if="previewImage" :href="previewImage.url" class="is-lightbox">
          <img :src="previewImage.url" class="img-fluid shop-item-image" :alt="previewImage.name">
        </a>
        <div class="flex padd30t">
          <div class="img-fluid shop-additional-item-image-wrapper"
            v-for="media in variantMedia.filter(x => (!previewImage || previewImage &&  x.id != previewImage.id))">
            <a :href="media.url" class="is-lightbox">
              <img :src="media.url" class="shop-additional-item-image" style="margin:12px;max-height: 60px"
                :alt="media.name">
            </a>
          </div>
        </div>
      </div>

      <div class="item-to-cart col-md-5 mb-4">
        <div class="p-4">
          <div class="mb-3">
            <h3>{{item.name}}</h3>

            <!-- Average rating -->
            <div v-if="eshopProductsReviewsSetting == 1" class="reviews-average">
              <template v-if="averageRating > 0">
                <span v-for="i in 5" :key="i" class="fa-stack" style="width:1em">
                  <i class="far fa-star fa-stack-1x"></i>
                  <i v-if="averageRating >= i" class="fas fa-star fa-stack-1x"></i>
                  <i v-else-if="averageRating == i - 0.5" class="fas fa-star-half fa-stack-1x"></i>
                </span>
                <h6 class="badge badge-secondary" style="margin: 2px 1px; font-size: x-small">{{ reviewsCount }} {{
                  __t_choice('webapp.reviews', reviewsCount) }}</h6>
              </template>
              <template v-else>
                <span v-for="i in 5" :key="i" class="fa-stack" style="width:1em">
                  <i class="far fa-star fa-stack-1x"></i>
                </span>
                <h6 class="badge badge-secondary" style="margin: 2px 1px; font-size: x-small">{{
                  __t('webapp.no_reviews') }}</h6>
              </template>
            </div>

            <span v-if="!hasVariants && item.sku" class="sku">SKU: {{item.sku}}</span>
            <span v-if="hasVariants && specifiedVariant && specifiedVariant.sku" class="sku"> SKU:
              {{specifiedVariant.sku}}</span>

            <span v-for="tag in item.tags">
              <a :href="`${shopUrl}?tags[]=${tag}`">
                <span class="badge mr-1">{{tag}}</span>
              </a>
            </span>
          </div>
          <div>
            <span v-if="specifiedVariant">
                <span v-if="parseFloat(discVariantPrice) !== parseFloat(specifiedVariant.price)">
                  <del>{{ adjustedDeletedPrice(specifiedVariant.price) }} {{ currency }}</del>
                </span>
                <span v-else-if="parseFloat(specifiedVariant.compare_at_price) > parseFloat(item.price)">
                  <del>{{ adjustedDeletedPrice(specifiedVariant.compare_at_price) }} {{ currency }}</del>
                </span>

                <span>{{ finalPriceOfItem() }} {{ currency }}</span>
            </span>
            <span v-else>
                <span v-if="hasRange === '1'">{{ __t('shop.product.from') }}</span>
                <span v-if="parseFloat(priceBefore) > parseFloat(priceAfter)">
                  <del>{{ adjustedDeletedPrice(priceBefore) }} {{ currency }}</del>
                </span>
                <span v-else-if="parseFloat(item.compareAtPrice) > parseFloat(item.price)">
                  <del>{{ adjustedDeletedPrice(item.compareAtPrice) }} {{ currency }}</del>
                </span>

                <span>{{ finalPriceOfItem() }} {{ currency }}</span>
            </span>
          </div>

            
            <!-- variants -->
            <div v-for="optionGroup in effectiveVariantOptionGroups" :key="optionGroup.id" class="variant-group">
              <label class="variant-label">{{ optionGroup.name }}</label>

              <!-- Color group: custom dropdown -->
              <div v-if="isColorGroup(optionGroup)" class="custom-select-wrapper">
                <button
                  type="button"
                  class="custom-select-trigger"
                  :class="{ 'is-open': openDropdownId === optionGroup.id }"
                  @click.stop="toggleDropdown(optionGroup.id)"
                >
                  <span class="custom-select-value">
                    <template v-if="getSelectedOption(optionGroup)">
                      <span class="option-color-dot" :style="{ backgroundColor: getSelectedOption(optionGroup).color }"></span>
                      <span>{{ getSelectedOption(optionGroup).name }}</span>
                    </template>
                    <span v-else class="custom-select-placeholder">Select an option</span>
                  </span>
                  <svg class="custom-select-chevron" :class="{ rotated: openDropdownId === optionGroup.id }" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                    <path fill-rule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clip-rule="evenodd" />
                  </svg>
                </button>
                <div v-show="openDropdownId === optionGroup.id" class="custom-select-dropdown">
                  <div
                    v-for="option in uniqueOptions(optionGroup)"
                    :key="option.id"
                    class="custom-select-option"
                    :class="{
                      'is-selected': String(selectedVariant[optionGroup.id]) === String(option.id),
                      'is-unavailable': !isOptionAvailable(optionGroup, option)
                    }"
                    @click.stop="selectColorOption(optionGroup, option)"
                  >
                    <span class="option-color-dot" :style="{ backgroundColor: option.color || '#e5e7eb' }"></span>
                    <span>{{ option.name }}</span>
                  </div>
                </div>
              </div>

              <!-- Non-color group: styled native select -->
              <select
                v-else
                class="variant-select"
                :value="selectedVariant[optionGroup.id]"
                @change="handleOptionSelectById(optionGroup, $event.target.value)"
              >
                <option disabled value="">Select an option</option>
                <option
                  v-for="option in uniqueOptions(optionGroup)"
                  :key="option.id"
                  :value="option.id"
                  :disabled="!isOptionAvailable(optionGroup, option)"
                >
                  {{ option.name }}
                </option>
              </select>
            </div>

            <!-- options/extras -->
           <item-options
              ref="itemOptions"
              :item="item"
              :discPrice="discVariantPrice"
              :variant="specifiedVariant"
              type="add"
              :quantity="quantity"
              :total-cost="totalCost"
              :bus="eventBus"
              @cost-changed="totalCost = $event"
            />

            <hr>

          <div v-if="hasVariants">
            <div v-if="variantSelectionMessage" class="alert" :class="variantSelectionAlertClass">
              {{variantSelectionMessage}}
            </div>
          </div>
          <div v-else>
            <div v-html="itemAvailabilityHtml"></div>
          </div>

          <br>
          <div class="flex justify-between">
            <quantity-control :quantity="quantity" @change="handleQuantityChange" />
            <div>
              {{ totalCostWithVat }} {{currency}}
            </div>     

          </div>

          <div style="padding-top:50px">
            <button @click.prevent="addToCart" :disabled="!canAddToCart"
              class="btn is-btn-primary shop-button shop-add-to-cart-button btn-block" type="submit">
              <i class="fas fa-shopping-cart"></i>
              {{__t('shop.product.add_to_cart')}}

            </button>
          </div>


        </div>

      </div>

      <add-to-cart-sidebar :currency="currency" :cost="totalCost" :item="item"
        :minimum-purchase-amount-enabled="minimumPurchaseAmountEnabled === '1'"
        :minimum-purchase-amount="parseFloat(minimumPurchaseAmount)" ref="addToCartSidebar" />

    </div>

  </div>
</template>
<script>

import select2 from '@/components/ui/select2';
import QuantityControl from './common/quantity-control';
import itemOptions from './item-options';
import addToCartSidebar from './add-to-cart-sidebar';
import SimpleLightbox from 'simplelightbox';
import 'simplelightbox/dist/simple-lightbox.min.css';

import { mapActions } from 'vuex';
import { mapGetters } from 'vuex';

export default {
    components: {select2,QuantityControl,itemOptions,addToCartSidebar},
    data: function(){
        return {
          lightbox: null,
          eventBus: new Vue(),
          previewImage: null,
          item: null,
          discPrices: null,
          currency: window.currency,
          quantity: 1,
          selectedVariant: {},
          specifiedVariant: null,
          defaultVariant: null,
          validVariants: [],
          originalVariantPrice: null,
          validSelectedVariant: false,
          variantSelectionAlertClass: '',
          variantSelectionMessage : '',
          totalCost: 0,
          vatPercentage: null,
          discVariantPrice: 0,
          openDropdownId: null,
        }
    },
    props:{
      cartUrl: String,
      itemJson: String,
      discountPrices: String,
      shopUrl: String,
      priceAfter: String,
      priceBefore: String,
      hasRange: String,
      averageRating: String,
      reviewsCount: String,
      eshopProductsReviewsSetting: String,
      defaultVat: {
        type: Object,
        default: null // Allowing null as a default value
      },
      b2bEnabled : {
        type: String, 
        required: true
      },
      minimumPurchaseAmountEnabled: {
        type: [String, Boolean],
        required: true
      },
      minimumPurchaseAmount: {
        type: Number,
        required: true
      },
    },
    methods:{
      ...mapActions([
        'addItemToCart',
        'initCart',
        'fetchShopInfo',
        'removeFromCart'
      ]),
      initLightBox() {
      if (this.lightbox) this.lightbox.destroy();

      this.lightbox = new SimpleLightbox('a.is-lightbox', {
        closeText: '<i style="font-size:35px" class="icon ion-ios-close-empty"></i>',
        navText: ['<i class="icon ion-ios-arrow-left"></i>', '<i class="icon ion-ios-arrow-right"></i>'],
        doubleTapZoom: 2,
        maxZoom: 10,
        disableScroll: false
      });
      },
      handleQuantityChange(value){

        if(!this.hasVariants && this.item.stock < value){
          if(this.item.track_stock && !this.item.allow_backorders){
            return;
          }else{
            this.quantity = value;
            return;
          }
        }

        if(this.hasVariants && this.specifiedVariant == null)
          return;

        if(this.hasVariants && this.specifiedVariant.stock < value){
          return;
        }

        this.quantity = value;
      },
      addToCart(){
        var item = this.item;

        var itemOptionsData = this.$refs.itemOptions.get();
        var comments = itemOptionsData.comments;
        var quantity = itemOptionsData.quantity;
        var options  = itemOptionsData.options;
        var variant = this.specifiedVariant;

        this.addItemToCart({
          item,
          comments,
          quantity,
          options,
          variant
        }).then(added => {
          if(added){
            this.$refs.addToCartSidebar.setOptions(options)
            this.$refs.addToCartSidebar.setVariant(variant)
            this.$refs.addToCartSidebar.flash();
            // toastr.success(this.__t('shop.product.added_to_cart',{name: item.name}));
          }
        });


      },
      handleOptionSelect(optionGroup, option) {
        // Update the selected option for the specific option group
        this.$set(this.selectedVariant, optionGroup.id, option.id);
        // Find the matching variant based on selected options
        const matchingVariant = this.findMatchingVariant(option);
        if (matchingVariant) {
          this.specifiedVariant = matchingVariant;

          // Update the preview image based on the selected variant
          this.previewImage = this.getVariantImage(optionGroup, option) || this.item.media[0];
          this.$nextTick(() => { this.initLightBox(); });
        } else {
          console.warn('No matching variant found.');
        }
      },
      handleOptionSelectById(optionGroup, optionId) {
        if (!optionId) {
          this.$set(this.selectedVariant, optionGroup.id, '');
          return;
        }

        const option = this.uniqueOptions(optionGroup)
          .find(candidate => String(candidate.id) === String(optionId));

        if (!option) {
          this.$set(this.selectedVariant, optionGroup.id, '');
          return;
        }

        this.handleOptionSelect(optionGroup, option);
      },
      isColorGroup(optionGroup) {
        return this.uniqueOptions(optionGroup).some(o => o.color);
      },
      getSelectedOption(optionGroup) {
        const selectedId = this.selectedVariant[optionGroup.id];
        if (!selectedId) return null;
        return this.uniqueOptions(optionGroup).find(o => String(o.id) === String(selectedId)) || null;
      },
      toggleDropdown(groupId) {
        this.openDropdownId = this.openDropdownId === groupId ? null : groupId;
      },
      selectColorOption(optionGroup, option) {
        if (!this.isOptionAvailable(optionGroup, option)) return;
        this.handleOptionSelectById(optionGroup, String(option.id));
        this.openDropdownId = null;
      },
      getVariantImage(optionGroup, option) {
        // Find the first variant that matches the selected option
        const variant = this.item.variants.find((variant) => {
        return variant.values.some(
            (value) => value.option && String(value.optionGroupId) === optionGroup.id && value.option.id === option.id
          );
        });

        // Return the media URL if the variant has associated media
        return variant && variant.media.length > 0 ? variant.media[0] : null;
      },
      findMatchingVariant(option) {
        // Iterate through the variants to find a match
        for (let variant of this.item.variants) {
          let match = false;
          // TODO probably could be a map / find instead of loob - break
          for (let value of variant.values) {
            if (value.option && option.id === value.option.id) {
              match = true;
              break;
            }
          }

          if (match) {
            return variant;
          }
        }

        return null;
      },
      uniqueOptions(optionGroup) {
        const seenOptions = new Set();
        return this.item.variants
          .flatMap((variant) => {
            const value = variant.values.find(
              (value) => String(value.optionGroupId) === optionGroup.id
            );
            return value && value.option ? [value.option] : [];
          })
          .filter((option) => {
            if (seenOptions.has(option.id)) return false;
            seenOptions.add(option.id);
            return true;
          });
      },
      isOptionAvailable(optionGroup, option) {
        return this.item.variants.some((variant) => {
          return variant.values.some(
            (value) => value.option && String(value.optionGroupId) === optionGroup.id && value.option.id === option.id
          );
        });
      },
      initUserSelectedVariants() {
        const selectedVariant = {};
        this.effectiveVariantOptionGroups.forEach(group => {
          selectedVariant[group.id] = '';
        });
        this.selectedVariant = selectedVariant;
      },
      initValidVariants() {
        this.validVariants = this.item.variants.map(variant => {
          const validVariant = {};
          validVariant.id = variant.id;
          variant.values.forEach(value => {
            if (value.option) {
              validVariant[value.optionGroupId] = value.option.id;
            }
          });
          return validVariant;
        });
      },
      initDefaultVariant() {
        this.defaultVariant = this.item.variants.find(variant => variant.is_default === 1);

        if (this.defaultVariant) {
          // Select default variant's options
          this.effectiveVariantOptionGroups.forEach(optionGroup => {
            const value = this.defaultVariant.values.find(value => String(value.optionGroupId) === optionGroup.id);
            const option = value?.option;

            if (option) {
              this.handleOptionSelect(optionGroup, option);
            }
          });
        }
      },
      vatAmount() {
        const discountVariantPrice = parseFloat(this.specifiedVariant ? this.discVariantPrice : this.priceAfter);
        this.vatAmountValue = parseFloat(discountVariantPrice -  discountVariantPrice / (1 + this.vatPercentage / 100)).toFixed(2);
        return this.vatAmountValue;
      },
      finalPriceOfItem() {
        const discountVariantPrice = parseFloat(this.specifiedVariant ? this.discVariantPrice : this.priceAfter);

        if (this.b2bEnabled === 'true' && !this.item.include_vat) {
          return (discountVariantPrice / (1 + this.vatPercentage / 100)).toFixed(2);
        }

        return discountVariantPrice.toFixed(2);
      },
      adjustedDeletedPrice(originalPrice) {
        let adjustedPrice = parseFloat(originalPrice);

        if (this.b2bEnabled === 'true' && !this.item.include_vat) {
          adjustedPrice = adjustedPrice / (1 + this.vatPercentage / 100);
        }

        return adjustedPrice.toFixed(2);
      },
      fetchVatCategory() {
        const vatCategoryId = this.item.vat_category_id;
        const alias = window.company_alias;
        
        if (!vatCategoryId) {
          this.vatPercentage = null;
          if(this.defaultVat){
            this.vatPercentage = this.defaultVat.percentage;
          }
          return;
        }

        fetch(route('webapp.shop.vat_category',  {alias, vatCategory_id : vatCategoryId }))
            .then(response => {
              if (!response.ok) {
                throw new Error('Network response was not ok');
              }
              return response.json();
            })
            .then(data => {
              this.vatPercentage = data.percentage;
            })
            .catch(error => {
              console.error('Error fetching VAT category percentage:', error);
            });
        },
      calculateDiscVariantPrice() {
        this.discVariantPrice = parseFloat(this.priceAfter).toFixed(2);
      },
      
    },   
    computed:{
        effectiveVariantOptionGroups() {
          if (this.item && this.item.variantOptionGroups && this.item.variantOptionGroups.length > 0) {
            return this.item.variantOptionGroups;
          }
          // Derive unique option groups from variants' values when pivot data is missing
          if (!this.item) return [];
          const seen = new Set();
          const groups = [];
          this.item.variants.forEach(variant => {
            variant.values.forEach(value => {
              if (value.optionGroup && !seen.has(value.optionGroup.id)) {
                seen.add(value.optionGroup.id);
                groups.push(value.optionGroup);
              }
            });
          });
          return groups;
        },
        variantMedia(){
          if(!this.specifiedVariant) return this.item.media;
          return this.specifiedVariant.media;
        },
        ...mapGetters({cart: 'getCart'}),
        hasVariants(){
          return this.item.variants.length > 0;
        },
        itemAvailabilityHtml(){
          var message = '';
          var alertClass   = '';

          function htmlMessage(message,alertClass){
            return `<div class="alert ${alertClass}">${message}</div>`
          }

          // doesn't track stock or tracks and has stock
          if(!this.item.track_stock || (this.item.track_stock && this.item.stock > 0)){
            message = this.__t('shop.product.available');
            alertClass = 'alert-success';
            return htmlMessage(message,alertClass);
          }

          if(this.item.allow_backorders){
            message = this.__t('shop.product.available_for_backorder');
            alertClass = 'alert-warning';
            return htmlMessage(message,alertClass);
          }

            message = this.__t('shop.product.out_of_stock');
            alertClass = 'alert-danger';
            return htmlMessage(message,alertClass);


        },
        canAddToCart(){
          if(this.item.variants.length){
            return this.validSelectedVariant;
          }

          return true;
        },
        computeVatAmount() {
          const discVariantPrice = parseFloat(this.priceAfter);
          this.vatAmountValue = parseFloat( discVariantPrice * (this.vatPercentage / 100)).toFixed(2);
          return this.vatAmountValue ;
        },
        // priceWithVat() {
        //   const discVariantPrice = parseFloat(this.priceAfter);
        //   return parseFloat(discVariantPrice + this.vatAmount);
        // },

        totalCostWithVat() {
          const totalVat = parseFloat(this.quantity * this.vatAmount());
          if(this.b2bEnabled === 'true' && !this.item.include_vat) {
            this.totalCost = (parseFloat(this.totalCost) - totalVat).toFixed(2);
          }else if(this.b2bEnabled === 'false' && this.item.include_vat) {
            this.totalCost = (parseFloat(this.totalCost) + totalVat).toFixed(2);
          }else {
            this.totalCost = (parseFloat(this.totalCost)).toFixed(2);
          }

        return parseFloat(this.totalCost).toFixed(2);
        },
    },
    watch: {
      selectedVariant: {
        deep: true,
        handler(value, oldSelectedVariant) {
              var valid = false;
              var variantSelectionMessage = '';
              var specifiedVariant = null;
              var variantSelectionAlertClass = '';


            this.validVariants.forEach(validVariant => {
              if(this.$_.isEqual(value, this.$_.omit(validVariant,'id'))){
                var variant = this.item.variants.find(x => x.id == validVariant.id);
                specifiedVariant = variant;
                if(Object.keys(this.discPrices).length > 0){
                  for (var key in this.discPrices) {
                    if(key == specifiedVariant.id){
                      this.discVariantPrice = this.discPrices[key];
                    }
                  }
                }else{
                  this.discVariantPrice = specifiedVariant.price;
                }
               
                if(variant.media[0]){
                  this.previewImage = variant.media[0];
                }else{
                  this.previewImage = this.item.media[0];
                }

                if(!variant.track_stock) {
                  valid = true;
                  variantSelectionAlertClass = 'alert-success';
                  variantSelectionMessage = this.__t('shop.product.available');
                }else if(variant.stock >= this.quantity){
                  valid = true;
                  variantSelectionAlertClass = 'alert-success';
                  variantSelectionMessage = this.__t('shop.product.in_stock',{stock: variant.stock});
                }else{
                  if(variant.allow_backorders){
                      valid = true;
                      variantSelectionAlertClass = 'alert-warning';
                      variantSelectionMessage = this.__t('shop.product.available_for_backorder');
                  }else{
                      valid = false;
                      variantSelectionAlertClass = 'alert-danger';
                      variantSelectionMessage = this.__t('shop.product.out_of_stock');
                  }
                }
              }

              });

              this.specifiedVariant = specifiedVariant;
              this.validSelectedVariant = valid;
              this.variantSelectionMessage = variantSelectionMessage;
              this.variantSelectionAlertClass = variantSelectionAlertClass

          }
        }
      },
    mounted(){
      this.initLightBox();
      this.calculateDiscVariantPrice();
      this._closeDropdownHandler = (e) => {
        if (!e.target.closest('.custom-select-wrapper')) {
          this.openDropdownId = null;
        }
      };
      document.addEventListener('click', this._closeDropdownHandler);
    },
    beforeDestroy() {
      document.removeEventListener('click', this._closeDropdownHandler);
    },
    created(){
      this.initCart(window.company_alias);
      this.fetchShopInfo();

      this.item = JSON.parse(this.itemJson);
      this.discPrices = JSON.parse(this.discountPrices);

      this.previewImage = this.item.media[0];

      if(this.item.variants.length){

        // init user selected variants
        this.initUserSelectedVariants();
        // init valid variants
        this.initValidVariants();

      }
 
    this.fetchVatCategory();
    this.initDefaultVariant();
  }
}
</script>

<style scoped>
  .variant-group {
    margin: 16px 0;
  }

  .variant-label {
    display: block;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #374151;
    margin-bottom: 8px;
  }

  /* Native select — non-color groups */
  .variant-select {
    width: 100%;
    height: 44px;
    padding: 0 40px 0 14px;
    border: 1.5px solid #d1d5db;
    border-radius: 8px;
    background-color: #fff;
    color: #111827;
    font-size: 14px;
    appearance: none;
    -webkit-appearance: none;
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20' fill='%236b7280'%3E%3Cpath fill-rule='evenodd' d='M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z' clip-rule='evenodd'/%3E%3C/svg%3E");
    background-repeat: no-repeat;
    background-position: right 12px center;
    background-size: 18px;
    cursor: pointer;
    transition: border-color 0.15s, box-shadow 0.15s;
  }

  .variant-select:focus {
    outline: none;
    border-color: #111827;
    box-shadow: 0 0 0 3px rgba(17,24,39,0.12);
  }

  .variant-select:disabled {
    background-color: #f3f4f6;
    color: #9ca3af;
    cursor: not-allowed;
  }

  /* Custom dropdown — color groups */
  .custom-select-wrapper {
    position: relative;
    user-select: none;
  }

  .custom-select-trigger {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    height: 44px;
    padding: 0 12px 0 14px;
    border: 1.5px solid #d1d5db;
    border-radius: 8px;
    background-color: #fff;
    color: #111827;
    font-size: 14px;
    cursor: pointer;
    transition: border-color 0.15s, box-shadow 0.15s;
    text-align: left;
  }

  .custom-select-trigger.is-open,
  .custom-select-trigger:focus {
    outline: none;
    border-color: #111827;
    box-shadow: 0 0 0 3px rgba(17,24,39,0.12);
  }

  .custom-select-value {
    display: flex;
    align-items: center;
    gap: 8px;
    flex: 1;
    overflow: hidden;
  }

  .custom-select-placeholder {
    color: #9ca3af;
  }

  .custom-select-chevron {
    width: 18px;
    height: 18px;
    color: #6b7280;
    flex-shrink: 0;
    transition: transform 0.2s;
  }

  .custom-select-chevron.rotated {
    transform: rotate(180deg);
  }

  .custom-select-dropdown {
    position: absolute;
    top: calc(100% + 4px);
    left: 0;
    right: 0;
    background: #fff;
    border: 1.5px solid #d1d5db;
    border-radius: 8px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.1);
    z-index: 200;
    max-height: 220px;
    overflow-y: auto;
  }

  .custom-select-option {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 14px;
    font-size: 14px;
    color: #111827;
    cursor: pointer;
    transition: background-color 0.1s;
  }

  .custom-select-option:hover:not(.is-unavailable) {
    background-color: #f3f4f6;
  }

  .custom-select-option.is-selected {
    background-color: #f9fafb;
    font-weight: 600;
  }

  .custom-select-option.is-unavailable {
    opacity: 0.4;
    cursor: not-allowed;
  }

  .option-color-dot {
    display: inline-block;
    width: 18px;
    height: 18px;
    border-radius: 50%;
    border: 1.5px solid rgba(0,0,0,0.12);
    flex-shrink: 0;
  }

  .item-to-cart {
    position:sticky;
    top:20px;
  }
</style>

